import MailingRecipientJson, { validateMailingRecipientJson } from "./MailingRecipientJson";
import { Validation } from "./Validation";

/**
 * Liste an E-Mail Empfänger zur Auswahl für eine Mailingaussendung.
 */
export default interface MailingListJson {
    ID: number | null,

    /**
     * Name der Mailingliste.
     */
    name: string;

    /**
     * Gibt an, ob diese Mailingliste ausgewählt werden kann beim anmelden.
     */
    isSignUpPublic: boolean;
}

export function validateMailingListJson(item: MailingListJson) {
    return new Validation(item)
        .validateInteger("ID", 0, null, false)
        .validateNonEmptyString("name", 100)
        .finish();
}
export function validateMailingListJsonAdd(item: MailingListJson) {
    return new Validation(item)
        .validateEquals("ID", null)
        .validateNonEmptyString("name", 100)
        .finish();
}